export default "__VITE_ASSET__CUPG9kAf__"